/**
 * @Des 新增/编辑 账户 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form label-width="120px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
            <el-form-item v-if="dialogForm.editFlag"  label="登陆账户：" prop="account" style="margin-bottom: 10px;">
                <div style="line-height: 40px;padding-left: 10px;">
                    {{dialogRowForm.account}}
                </div>
            </el-form-item>
            <el-form-item v-if="!dialogForm.editFlag" label="登陆账户：" prop="account">
              <el-input v-model="dialogRowForm.account" auto-complete="off" autocomplete="false" clearable @blur="getAccount(true)" @input="getAccount(false)"/>
            </el-form-item>
            <el-form-item v-if="!dialogForm.editFlag || dialogForm.editFlag == 'resetpwd'" label="密码：" prop="password">
              <el-input v-model="dialogRowForm.password" type="password" auto-complete="password" autocomplete="false" clearable :disabled="dialogRowForm.passwordDisabled"/>
            </el-form-item>
            <el-form-item v-if="!dialogForm.editFlag || dialogForm.editFlag == 'resetpwd'" label="确认密码：" prop="repassword">
              <el-input v-model="dialogRowForm.repassword" type="password" auto-complete="repassword" autocomplete="false" clearable :disabled="dialogRowForm.repasswordDisabled"/>
            </el-form-item>
            <el-form-item v-if="dialogForm.editFlag != 'resetpwd'" label="角色：" prop="roleId" :style="{display: this.dialogRowForm.roleShow}">
                <TreeSelect :data="roles" :selectTree="roleSelectTree" ref="treeSelect" @setSelectVal="setSelectVal" />
            </el-form-item>
            <el-form-item v-if="dialogForm.editFlag != 'resetpwd'" label="姓名：" prop="userName">
				        <el-input v-model="dialogRowForm.userName" clearable :disabled="dialogRowForm.userNameDisabled"/>
            </el-form-item>
            <el-form-item class="btn-form-item-c">
                <el-button type="primary" size="primary" :disabled="!dialogForm.editFlag && this.dialogRowForm.roleShow == 'none'" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

<script>
    // 交互 接口
    import ApiAccount from '@/request/api-account'
    // 下拉树结构 组件
    import TreeSelect from '@/components/TreeSingleSelect.vue'
    // 校验 组件
    import {validFormat, checkFormat} from '@/global/global-valid'

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'AccountDialog',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
            // 角色集合
            roles: Array,
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
            // 选择树
            TreeSelect,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    editFlag: false,
                    title: "",
                    dialogFormVisible: false,
                    submitButton: ''
                },
                /**
                 * @Des 角色树选择
                 * @Auth
                 * @Date 2021/6/19
                 */
                roleSelectTree:{
                    // 提示语
                    placeholder: '',
                    // 关键词 过滤
                    keywordFilter: false,
                    // 节点复选框
                    showBox: false,
                },
                /**
                 * @Des 修改表单
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogRowForm: {
                	// 当前账户
                	accountId: '',
                	// row 下标
                  rowIndex: -1,

                  // 登录账户
                  account: '',
                  // 密码
                  password: '',
                  // 密码
                  repassword: '',
                  // 备注
                  remarks: '',
                  // 角色id
                  roleId: '',
                  // 用户名称
                  userName: '',
                  passwordDisabled: false,
                  repasswordDisabled: false,
                  userNameDisabled: false,
                  roleShow: 'none'



                },

                /**
                 * @Des 弹窗规则
                 * @Auth
                 * @Date 2021/6/19
                 */
                rules: {
                    roleId: [
                        { required: true, message: '请选择角色', trigger: 'false' },
                    ],
                    userName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    account: [
                        { required: true, message: '请输入账户', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.num_letter_underline)) {
	                            	new callback(new Error("登录账户可包含：字母、数字、下划线"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.password) && false) {
	                            	new callback(new Error("6-18位，可包含数字、字母、英文符号"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                    repassword: [
                        { required: true, message: '请再次输入密码', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
								if (!checkFormat(value, validFormat.password) && false) {
									new callback(new Error("6-18位，可包含数字、字母、英文符号"));
								} else if (this.dialogRowForm.repassword != this.dialogRowForm.password) {
	                            	new callback(new Error("两次密码输入不一致"));
	                            } else {
									callback()
								}
	                        },
	                        trigger: "blur"
                        }
                    ],
                }// rules
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(editFlag, data, rowIndex){
                // console.log(data);
                this.dialogForm.dialogFormVisible = true;

                this.dialogForm.editFlag = editFlag;
                this.dialogForm.title = (!editFlag ? '新增账户' : editFlag == 'resetpwd' ? '重置密码' : '编辑账户');
				        this.dialogForm.submitButton = "提交";

                // 新增账户
                if (!editFlag) {
                	this.dialogRowForm.accountId = this.$store.state.account;
                	this.$nextTick(() => {
	                    // 加载完DOM后执行
	                    this.$refs['treeSelect'].setSelectVal({});
	                });
                }

                if (!this.$checkEmpty(data)) {

	                // 当前账户
	                //this.dialogRowForm.accountId = data.accountId;
	                // row 下标
	                //this.dialogRowForm.rowIndex = rowIndex;

	                // 表单
	                this.dialogRowForm = Object.assign({}, this.dialogRowForm, data, {rowIndex: rowIndex});

	                let roleIds = {}
	                data.roles.forEach((row,index) => {
	                    roleIds = {
	                        id: row.roleId,
	                        label: row.roleName
	                    }
	                });

	                // 角色id
	                this.dialogRowForm.roleId = roleIds.id;

	                // 非重置密码
	                if (editFlag != 'resetpwd') {
	                	this.$nextTick(() => {
		                    // 加载完DOM后执行
		                    this.$refs['treeSelect'].setSelectVal(roleIds);
		                });
	                }

                }

            },

            /**
             * @Des 提交账户信息
             * @Auth
             * @Date 2021/6/19
             */
            submitForm(){
                // console.log(this.dialogRowForm)
                /**
                * @Des 表单校验
                * @Auth
                * @Date 2021/6/19
                */
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;

                    // 交互参数
                    let params = {
                    	accountId: this.dialogRowForm.accountId,
                      account: this.dialogRowForm.account,
                      userName: this.dialogRowForm.userName,
                      password: this.dialogRowForm.password,
                      roleIds: [this.dialogRowForm.roleId],
                      projectId: this.$store.state.currentProjectId
                    };

                    // 交互 路径
                    let submitApi = (!this.dialogForm.editFlag ? ApiAccount.addAccountApi : ApiAccount.updateAccountApi);

					          // 重置密码
                    if (this.dialogForm.editFlag == 'resetpwd') {
                        // 交互参数
                        params = {
                          accountId: this.dialogRowForm.accountId,
                          password: this.dialogRowForm.password
                        };

                      // 交互 路径
                      submitApi = ApiAccount.resetPwdApi;
                    }

                    /**
                    * @Des 数据交互
                    * @Auth
                    * @Date 2021/6/19
                    */
                    this.$request.postJsonRequest(submitApi, params).then(result => {
                        if(result.code == 0){
                            let message = (!this.dialogForm.editFlag ? '账户【'+ this.dialogRowForm.account +'】新增成功成功！' : this.dialogForm.editFlag == 'resetpwd' ? '账户【'+ this.dialogRowForm.account +'】密码重置成功' : '账户【'+ this.dialogRowForm.account +'】修改成功！');
                            this.$message({
                                message: message,
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            // 关闭弹窗
                            this.dialogForm.dialogFormVisible = false;
                            if(this.dialogForm.editFlag){
                                // 编辑成功

                                // 重置密码
                                if (this.dialogForm.editFlag == 'resetpwd') {

                                	// 当前 登录账户
                                	if (this.dialogRowForm.account == this.$store.state.account) {
                                		// 退出登录
                                      this.logOut();
                                      return false;
                                	}

                                }

                                // 刷新列表
                                this.$emit("search");
                            }else{
                                // 添加成功
                                this.$emit("setTotal", 0);
                            }
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('账户修改异常', submitApi, error);
                    })
                });// validata
            },

          /**
           * @Des 获取账户信息
           * @Auth
           * @Date 2021/6/19
           */
          getAccount(questFlag = true){
              // 空值 中止
              if (this.$checkEmpty(this.dialogRowForm.account)) {
              	this.dialogRowForm.roleShow = 'none';
              	return false;
              }
              
              // 非交互 中止
              if (!questFlag) return false;
              /**
               * @Des 数据交互
               * @Auth
               * @Date 2021/6/19
               */
              this.$request.postJsonRequest(ApiAccount.searchAccountsApi, {
                account: this.dialogRowForm.account
              }).then(result => {
              	const rows = Object.assign([], result.rows);
              	const row = rows[0];
              	
                if(!this.$checkEmpty(row)){
                  this.dialogRowForm.password = row.password;
                  this.dialogRowForm.repassword = row.password;
                  this.dialogRowForm.userName = row.userName;
                  this.dialogRowForm.roleId = Object.assign({}, row.roles[0]).roleId;
                  this.dialogRowForm.passwordDisabled = true;
                  this.dialogRowForm.repasswordDisabled = true;
                  this.dialogRowForm.userNameDisabled = true;
                  this.dialogRowForm.roleShow = 'none';
                }else{
                  this.dialogRowForm.password = '';
                  this.dialogRowForm.repassword = '';
                  this.dialogRowForm.userName = '';
                  this.dialogRowForm.roleId = '';
                  this.dialogRowForm.passwordDisabled = false;
                  this.dialogRowForm.repasswordDisabled = false;
                  this.dialogRowForm.userNameDisabled = false;
                  this.dialogRowForm.roleShow = 'block';
                }
              }).catch(error => {
                this.dialogRowForm.roleShow = 'none';
                console.error('账户查询异常', ApiAccount.Find_Account_By_Account_Uri, error);
              })
          },
            /**
             * @Des 退出登录
             * @Auth
             * @Date 2021/6/22
             */
            logOut() {
            	// 移除cookie
				      this.$cookies.remove("username");
              this.$cookies.remove("usernameSecret");
				      this.$cookies.remove("passwordSecret");
				      // 登录页面
				      this.$router.replace({path: '/'}, ()=>{}, ()=>{});
            },

          /**
           * @Des 选择值设置
           * @Auth
           * @Date 2021/6/19
           */
          setSelectVal(val){
            if (!this.$checkEmpty(val.id)) {
              // 角色id
              this.dialogRowForm.roleId = val.id;
              // 角色
              this.dialogRowForm.role = [{roleId: val.id, roleName: val.label}];
            } else {
              this.dialogRowForm.roleId = '';
              // 角色
              this.dialogRowForm.role = [{roleId: '', roleName: ''}];
            }
            // 校验
            this.$refs.dialogRowForm.validateField('roleId', error => {});
          },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
	            // 重置表单
	            this.reset();
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	            // 清除表单数据
	            this.cleanData(this.dialogRowForm)
	            // 清除表单验证
	            this.cleanValidate('dialogRowForm');
	        },

            /**
             * @Des 清除验证信息
             * @Auth
             * @Date 2021/6/19
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
	         * @Des 清除数据
	         * @Auth
	         * @Date 2021/6/19
	         */
	        cleanData(form){
	            // 重置表单数据
	            //this.$refs['dialogRowForm'].resetFields();

	            /*if (this.dialogForm.editFlag != 'resetpwd') {
		            // 重置 tree select 数据
					      this.$refs['treeSelect'].resetSelect();
	            }*/

	            // 延时执行
	            this.$nextTick(function () {
	                // 当前账户
	                form.accountId = '';
	                // row 下标
	                form.rowIndex = -1;
	                // 登录账户
                  form.account = '';
                  // 密码
                  form.password = '';
                  // 密码
                  form.repassword = '';
                  // 备注
                  form.remarks = '';
                  // 角色id
                  form.roleId = '';
                  // 用户名称
                  form.userName = '';
                  form.passwordDisabled = false;
                  form.repasswordDisabled = false;
                  form.roleNameDisabled = false;
                  form.userNameDisabled = false;
                  form.roleShow = 'none';
                  
	            });// 延时执行
	        },
        },// methods

    }
</script>
/* JS */

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Account/AccountDialog.vue